import React, { useState, useEffect } from "react";
import axios from "axios";
import login from "../../../services/login";
import API from "../../../config/api";
import { Text } from "react-native";
import "./styles.css";

const LocationAnalytics = () => {
	const [url, setUrl] = useState(null);
	const [loading, setLoading] = useState(true);
	const [iframeLoading, setIframeLoading] = useState(true);

	useEffect(() => {
		const fetchSession = async () => {
			try {
				const token = await login.getToken();
				console.log(token,"token");
				if (API() == "https://biz.safebuildingsapp.ca") {
					setUrl(`https://biz.safebuildingsapp.ca/login?token=${token}`)
				}
				else {
					setUrl(`https://devbiz.safebuildingsapp.ca/login?token=${token}`)
				}
			} catch (error) {
				console.error("Error fetching session:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchSession();
	}, []);

	const handleIframeLoad = () => {
		setIframeLoading(false);
	};

	return (
		<div style={styles.container}>
			{loading && !url ? (
				<div style={styles.loader}>Loading...</div>
			) : (
				<div style={styles.iframeContainer}>
					{iframeLoading && (
						<div style={styles.iframeLoader}>
							<div className="spinner" style={styles.spinner}></div>
							{/* <div style={styles.loadingText}>Loading...</div> */}
						</div>
					)}
					<iframe
						src={url}
						title="Location Analytics"
						style={styles.iframe}
						onLoad={handleIframeLoad}
					/>
				</div>
			)}
		</div>
	);
};

const styles = {
	container: {
		height: "100vh",
		width: "100%",
		position: "relative",
	},
	iframeContainer: {
		position: "relative",
		width: "100%",
		height: "100%",
	},
	iframe: {
		width: "100%",
		height: "100%",
		border: "none",
	},
	loader: {
		textAlign: "center",
		paddingTop: "40vh",
		fontSize: "1.5rem",
		color: "#0000FF",
	},
	iframeLoader: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		backgroundColor: "rgba(255, 255, 255, 0.9)",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 10,
	},
	spinner: {
		width: "50px",
		height: "50px",
		border: "4px solid #f3f3f3",
		borderTop: "4px solid #0000FF",
		borderRadius: "50%",
		animation: "spin 1s linear infinite",
		marginBottom: "20px",
	},
	loadingText: {
		fontSize: "1.2rem",
		color: "#0000FF",
		textAlign: "center",
	},
};

export default LocationAnalytics;
